/**
 * Every page in the internal webapp.
 *
 * A static list, because nothing serves one any more. Per-page access control —
 * a backend registry, a Firestore store of live overrides and an `/access`
 * screen — was removed while no page needed it, so there is no per-viewer
 * answer to ask for. Every signed-in employee sees every entry here.
 *
 * The rail and the launcher both read this, so a page appears in both or in
 * neither. Add an entry when you add its route under `src/routes`.
 */
export interface InternalPage {
  id: string
  path: string
  title: string
}

export const INTERNAL_PAGES: readonly InternalPage[] = Object.freeze([
  {
    id: 'blytzcollect-analytics',
    path: '/blytzcollect/analytics',
    title: 'BlytzCollect Analytics'
  },
  {
    id: 'ach-returns',
    path: '/payments/ach-returns',
    title: 'ACH returns'
  },
  {
    id: 'bin-mcc-fee-report',
    path: '/payments/bin-mcc-fee-report',
    title: 'BIN / MCC fee report'
  },
  {
    id: 'retry-analysis',
    path: '/reports/retry-analysis',
    title: 'Retry Analysis'
  }
])

/**
 * Compare two route paths without tripping over a trailing slash or a query.
 *
 * The rail marks the active row with this, so `/payments/ach-returns/` and
 * `/payments/ach-returns?window=7` must both match the declared path.
 *
 * @param pathname - The path to normalize.
 * @returns The path without its query string or trailing slash.
 */
export function normalizePath(pathname: string): string {
  const path = pathname.split('?')[0]

  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
}
